// Single source of truth for currency display. `money` → "$1,234.56"; `moneyWhole` → "$1,235".
const fmt2 = new Intl.NumberFormat(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const fmt0 = new Intl.NumberFormat(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 });

export const money = (n) => `$${fmt2.format(Number(n) || 0)}`;
export const moneyWhole = (n) => `$${fmt0.format(Number(n) || 0)}`;
// "—" for blank/unknown amounts (e.g. a pay rate not yet set), otherwise money().
export const moneyOrDash = (n) => (n == null || n === "" || Number.isNaN(Number(n)) ? "—" : money(n));
